import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    num: "01",
    title: "Charpente",
    desc: "Charpentes traditionnelles et fermettes, ossatures bois, extensions. Le bois est notre première langue : nous le choisissons, le taillons et l'assemblons pour durer des générations.",
    img: "/realisations/p5.jpg",
    alt: "Charpente lamellé-collé réalisée par Goujon Vallée, artisan charpentier en Normandie",
    span: "md:col-span-8",
  },
  {
    num: "02",
    title: "Couverture",
    desc: "Ardoise, tuile ou couverture métallique — zinc joint debout, aluminium — la finition tendance des toitures contemporaines. Réfection complète, réparation et entretien. Étanchéité garantie, finitions irréprochables.",
    img: "/realisations/p4.jpg",
    alt: "Rénovation de toiture ardoise sur maison à colombages par Goujon Vallée en Normandie",
    span: "md:col-span-4",
  },
  {
    num: "03",
    title: "Bardage",
    desc: "Bardage bois, composite ou métallique pour habiller et protéger vos façades. Une seconde peau qui allie esthétique et durabilité face au climat normand.",
    img: "/realisations/p2.jpg",
    alt: "Bardage de bâtiment tertiaire réalisé par Goujon Vallée en Normandie",
    span: "md:col-span-6",
  },
  {
    num: "04",
    title: "Isolation",
    desc: "Isolation de toiture par sarking et isolation thermique par l'extérieur (ITE) des murs. Entreprise certifiée RGE et Qualibat — gage de qualité : vos travaux d'isolation ouvrent droit aux aides de l'État, dont MaPrimeRénov'.",
    img: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=1200&auto=format&fit=crop",
    alt: "Isolation de toiture sarking et ITE par Goujon Vallée, entreprise certifiée RGE Qualibat en Normandie",
    span: "md:col-span-6",
    badges: ["RGE", "Qualibat", "MaPrimeRénov'"],
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-28 lg:py-40 max-w-7xl mx-auto px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8 }}
        className="mb-16 lg:mb-24"
      >
        <p className="text-xs tracking-[0.3em] uppercase text-jaune font-bold mb-4">Nos savoir-faire</p>
        <h2 className="font-display font-bold uppercase tracking-tight text-3xl sm:text-4xl md:text-5xl max-w-2xl leading-tight">
          Quatre métiers, une même exigence
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
        {SERVICES.map((s, i) => (
          <motion.article
            key={s.num}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: i * 0.1 }}
            className={`group relative border border-white/10 bg-[#121214] overflow-hidden ${s.span}`}
            data-testid={`service-card-${s.title.toLowerCase()}`}
          >
            <div className={`overflow-hidden ${s.span === "md:col-span-12" ? "h-72 md:h-96" : "h-72"}`}>
              <img
                src={s.img}
                alt={s.alt}
                loading="lazy"
                className="w-full h-full object-cover grayscale-[40%] transition-[transform,filter] duration-700 group-hover:scale-105 group-hover:grayscale-0"
              />
            </div>
            <div className="p-8 lg:p-10">
              <div className="flex items-start justify-between gap-6">
                <div>
                  <span className="text-xs tracking-[0.3em] text-jaune font-bold">{s.num}.</span>
                  <h3 className="font-display font-bold uppercase tracking-tight text-2xl mt-2">{s.title}</h3>
                  <p className="mt-4 text-sm text-zinc-400 leading-relaxed font-light max-w-xl">{s.desc}</p>
                  {s.badges && (
                    <div className="mt-5 flex flex-wrap gap-2">
                      {s.badges.map((b) => (
                        <span key={b} data-testid={`service-badge-${b.toLowerCase().replace(/[^a-z]/g, "")}`} className="border border-vert/70 text-vert px-3 py-1 text-[10px] tracking-[0.2em] uppercase font-bold">
                          {b}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
                <a
                  href="#contact"
                  data-testid={`service-cta-${s.title.toLowerCase()}`}
                  aria-label={`Demander un devis ${s.title}`}
                  className="shrink-0 w-12 h-12 border border-white/20 flex items-center justify-center text-zinc-400 group-hover:bg-jaune group-hover:text-black group-hover:border-jaune transition-colors duration-300"
                >
                  <ArrowUpRight className="w-5 h-5" />
                </a>
              </div>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
